import { waitingListQueries } from "lib/build/dashboards/ktx/queries";
import { Origin } from "lib/build/events";
import { diagnosisBaselineDiseaseMessages } from "lib/build/forms/ktx/basic-registration-data/waiting-list-data/kidneyDiseaseEthiology";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useLastEventByQuery } from "src/features/events";

export function useKidneyDiseaseEthiology(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<{ diagnosisBaselineDisease: string }>(
		waitingListQueries.kidneyDiseaseEthiology
	);
	const formatMessageMap = useFormatMessageMap();
	return event === undefined
		? { value: "-" }
		: {
				value: formatMessageMap(
					diagnosisBaselineDiseaseMessages,
					event.value.diagnosisBaselineDisease
				),
				timestamp: event.timestamp,
				origin: event.origin
			};
}
